module.exports = __webpack_public_path__ + "static/ease-icon-eec472aab10b87ff742921c0117336df.png";